import { net } from 'zf-web-infra';
import { CONFIG } from 'config';
import type * as Types from '../types';

export class LoginService {

  async login(data: Types.LoginParams): Promise<Types.LoginResponse> {
    let url = '/api/account/login';
    if (CONFIG.BANU_HOSTS.includes(location.hostname)) {
      url = '/api/account/banuLogin';
    }
    const response = await net.post<Types.LoginResponse>(url, data);
    document.cookie = `x-access-token=${response.accessToken}; path=/; SameSite=Lax`;
    return response;
  }

  async captcha(): Promise<Types.CaptchaResponse> {
    return await net.get<Types.CaptchaResponse>('/api/account/captcha');
  }

}
